export default (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.21642 1.36159C13.6617 0.99086 17.4064 4.33546 17.5 8.64792L17.5002 8.66602C17.5002 10.1734 17.0281 11.5823 16.1911 12.7921L16.1828 12.8039L11.9531 18.6969C11.9447 18.7086 11.936 18.7201 11.927 18.7313C10.9548 19.9476 9.04268 20.0224 8.10846 18.6933L3.87738 12.7983C2.77447 11.2347 2.1949 9.26047 2.66359 7.17118C3.24151 4.03839 5.97309 1.73215 9.19099 1.36411C9.19945 1.36314 9.20793 1.3623 9.21642 1.36159ZM9.36769 3.02144C6.79214 3.32125 4.72386 5.15473 4.30014 7.48698C4.29797 7.4989 4.29555 7.51076 4.29287 7.52257C3.93973 9.07758 4.35434 10.5816 5.23743 11.8349L9.47099 17.7333C9.69659 18.0559 10.2593 18.1314 10.6137 17.7048L14.8245 11.8382C15.4761 10.8939 15.8317 9.81795 15.8336 8.67506C15.7564 5.35985 12.8752 2.73585 9.36769 3.02144Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7.08317C9.12555 7.08317 8.41667 7.79205 8.41667 8.6665C8.41667 9.54095 9.12555 10.2498 10 10.2498C10.8745 10.2498 11.5833 9.54095 11.5833 8.6665C11.5833 7.79205 10.8745 7.08317 10 7.08317ZM6.75 8.6665C6.75 6.87158 8.20507 5.4165 10 5.4165C11.7949 5.4165 13.25 6.87158 13.25 8.6665C13.25 10.4614 11.7949 11.9165 10 11.9165C8.20507 11.9165 6.75 10.4614 6.75 8.6665Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7.08317C9.12555 7.08317 8.41667 7.79205 8.41667 8.6665C8.41667 9.54095 9.12555 10.2498 10 10.2498C10.8745 10.2498 11.5833 9.54095 11.5833 8.6665C11.5833 7.79205 10.8745 7.08317 10 7.08317ZM6.75 8.6665C6.75 6.87158 8.20507 5.4165 10 5.4165C11.7949 5.4165 13.25 6.87158 13.25 8.6665C13.25 10.4614 11.7949 11.9165 10 11.9165C8.20507 11.9165 6.75 10.4614 6.75 8.6665Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7.08317C9.12555 7.08317 8.41667 7.79205 8.41667 8.6665C8.41667 9.54095 9.12555 10.2498 10 10.2498C10.8745 10.2498 11.5833 9.54095 11.5833 8.6665C11.5833 7.79205 10.8745 7.08317 10 7.08317ZM6.75 8.6665C6.75 6.87158 8.20507 5.4165 10 5.4165C11.7949 5.4165 13.25 6.87158 13.25 8.6665C13.25 10.4614 11.7949 11.9165 10 11.9165C8.20507 11.9165 6.75 10.4614 6.75 8.6665Z"
      fill="currentColor"
    />
  </svg>
);
